import React from 'react';
import { WaiverSubmissionStatus } from '../../types/waivers';

export const ALL_STATUSES: WaiverSubmissionStatus[] = [
  'QUEUED',
  'SENT',
  'SIGNED',
  'PENDING_EMPLOYEE',
];

const getInitialStatuses = () => {
  const cachedStatuses = sessionStorage.getItem('waiver-submissions-statuses');
  const parsedCachedStatuses = cachedStatuses
    ? (JSON.parse(cachedStatuses) as WaiverSubmissionStatus[])
    : null;
  if (parsedCachedStatuses) {
    const filteredStatuses = parsedCachedStatuses.filter(status =>
      ALL_STATUSES.includes(status),
    );
    return filteredStatuses;
  }
  return ALL_STATUSES;
};

function useWaiverSubmissionsFilter() {
  const [statuses, setStatuses] = React.useState<WaiverSubmissionStatus[]>(
    getInitialStatuses(),
  );

  const onChange: typeof setStatuses = React.useCallback(payload => {
    setStatuses(prev => {
      const newStatuses =
        typeof payload === 'function' ? payload(prev) : payload;
      sessionStorage.setItem(
        'waiver-submissions-statuses',
        JSON.stringify(newStatuses),
      );
      return newStatuses;
    });
  }, []);

  return { statuses, onChange };
}

export default useWaiverSubmissionsFilter;
